import { createContext } from 'react';
import utils from '../../utils';

type GuideTourContextProps = { onShowGuide: () => void };

export default createContext<Partial<GuideTourContextProps>>({
  onShowGuide: utils.noop,
});
